module.exports = __webpack_public_path__ + "static/img/lasa.7abc6de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/lasa.png
// module id = Piw5
// module chunks = 1